import { useCacheControlListener } from '../hooks/useCacheControlListener.hook'
import { useInvoiceUploadListener } from './useInvoiceUploadListener.hook'
import { useNewAppVersionListener } from './useNewAppVersionListener.hook'
import { useVirtualMetersListener } from './useVirtualMetersListener.hook'

export const useGlobalListeners = () => {
  useNewAppVersionListener()
  useCacheControlListener()
  useVirtualMetersListener()
  useInvoiceUploadListener()
}
